import { render, staticRenderFns } from "./ShippingOrigin.vue?vue&type=template&id=52697c52&"
import script from "./ShippingOrigin.vue?vue&type=script&lang=js&"
export * from "./ShippingOrigin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports